import type { Route, Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { invitadoGuard } from '../../core/guards/seguridad.guard';

const layout = () => import('./layout-acceso.component').then((m) => m.LayoutAccesoComponent);

// Cada pantalla es una ruta de primer nivel con el layout de acceso y la página como hija.
// (Un padre con path '' delante de la tienda capturaría también la portada "/".)
function pantalla(path: string, title: string, pagina: NonNullable<Route['loadComponent']>, canActivate: Route['canActivate'] = []): Route {
  return { path, title, canActivate, loadComponent: layout, children: [{ path: '', loadComponent: pagina }] };
}

// Pantallas de acceso (SPEC §28.1: /login y /registro; RN-SEG-04: recuperar y restablecer)
export const ACCESO_ROUTES: Routes = [
  pantalla('login', 'Entrar · Pedidos SHEIN', () => import('./pages/login.page').then((m) => m.LoginPage), [invitadoGuard]),
  pantalla('registro', 'Quiero vender · Pedidos SHEIN', () => import('./pages/registro.page').then((m) => m.RegistroPage), [invitadoGuard]),
  pantalla('recuperar', 'Recuperar contraseña · Pedidos SHEIN', () => import('./pages/recuperar.page').then((m) => m.RecuperarPage)),
  pantalla('restablecer', 'Contraseña nueva · Pedidos SHEIN', () => import('./pages/restablecer.page').then((m) => m.RestablecerPage)),
  pantalla('cambiar-password', 'Elige tu contraseña · Pedidos SHEIN', () => import('./pages/cambiar-password.page').then((m) => m.CambiarPasswordPage), [authGuard]),
];
